import { Container, Row, Col, Nav } from 'react-bootstrap';
import { MyTasks } from '../../components';
import { Link, useLocation } from 'react-router-dom';
import TaskDetail from './detail/TaskDetail';

const Tasks = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    // Check if we're viewing a task detail
    const isTaskDetail = currentPath.includes('/tasks/detail/');

    return (
        <Container fluid className="tasks-page">
            <Row>
                <Col>
                    <h1 className="display-1">{isTaskDetail ? 'Task Details' : 'Tasks'}</h1>
                    <div className="display-2">{isTaskDetail ? 'View and Manage Task Information' : 'Manage Your Tasks'}</div>
                </Col>
                <Col>
                    <div className="text-end">
                        <Nav className="c-nav-tabs">
                            {isTaskDetail && (
                                <Nav.Item>
                                    <Nav.Link 
                                        as={Link}
                                        to="/tasks/detail/TASK-1"
                                        active={isTaskDetail}
                                    >
                                        Task Details
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks"
                                    active={currentPath === '/tasks'}
                                >
                                    Tasks
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/timesheet"
                                    active={currentPath === '/tasks/timesheet'}
                                >
                                    Quick Logs
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/all-timesheets"
                                    active={currentPath === '/tasks/all-timesheets'}
                                >
                                    All Timesheets
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/tasklist"
                                    active={currentPath === '/tasks/tasklist'}
                                >
                                    Tasklist
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/workflow"
                                    active={currentPath === '/tasks/workflow'}
                                >
                                    Workflow
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>
                    {isTaskDetail ? (
                        <TaskDetail taskId="TASK-001" />
                    ) : (
                        <MyTasks />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default Tasks;
